/* ========================================
   Kids Size Finder band
   ----------------------------------------
   Foot length in cm -> UK size -> an in-stock kids style in that size.
   Chart and stock are rendered server-side into two JSON script tags.
   ======================================== */

(function () {
  'use strict';

  function init(section) {
    if (!section || section.hasAttribute('data-size-finder-ready')) return;
    section.setAttribute('data-size-finder-ready', 'true');

    var form = section.querySelector('[data-size-finder-form]');
    var input = section.querySelector('[data-size-finder-input]');
    var result = section.querySelector('[data-size-finder-result]');
    var answer = section.querySelector('[data-size-finder-answer]');
    var sizeEl = section.querySelector('[data-size-finder-size]');
    var metaEl = section.querySelector('[data-size-finder-meta]');
    var shopBtn = section.querySelector('[data-size-finder-shop]');
    var shopLabel = section.querySelector('[data-size-finder-shop-label]');
    var message = section.querySelector('[data-size-finder-message]');
    var adultBtn = section.querySelector('[data-size-finder-adult]');
    if (!form || !input || !result) return;

    var chart = (readJSON(section.querySelector('[data-size-finder-sizes]')) || [])
      .filter(function (row) { return typeof row.maxFootMm === 'number' && row.maxFootMm > 0; })
      .sort(function (a, b) { return a.maxFootMm - b.maxFootMm; });
    var stock = readJSON(section.querySelector('[data-size-finder-stock]')) || {};

    var growingRoom = toNumber(section.getAttribute('data-growing-room'), 10);
    var shopText = section.getAttribute('data-shop-label') || 'Shop size';
    var noStockText = section.getAttribute('data-no-stock') ||
      'Sorry, we’re out of stock in this size right now. Check back soon, we restock regularly.';

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (adultBtn) adultBtn.hidden = true;

      var raw = parseFloat(String(input.value).replace(',', '.'));
      if (isNaN(raw)) {
        showMessage('Enter their foot length to find a size, e.g. 16.8');
        return;
      }

      // The field is in cm, but a parent may type millimetres (e.g. 168).
      var mm = raw >= 80 ? raw : raw * 10;
      var readAsMm = raw >= 80;

      if (mm < 80 || mm > 300) {
        showMessage('That doesn’t look like a child’s foot length. Please check and enter it in centimetres.');
        return;
      }
      if (!chart.length) {
        showMessage('Size chart is not available right now.');
        return;
      }

      var match = null;
      for (var i = 0; i < chart.length; i++) {
        if (mm <= chart[i].maxFootMm) { match = chart[i]; break; }
      }

      if (!match) {
        var largest = chart[chart.length - 1];
        showMessage('At ' + formatCm(mm) + ' cm they’re beyond our kids range, which goes up to ' +
          sizeName(largest) + '. Take a look at our adult sizes.');
        if (adultBtn) adultBtn.hidden = false;
        return;
      }

      render(match, mm, readAsMm);
    });

    function render(row, mm, readAsMm) {
      var room = Math.max(0, Math.round(row.maxFootMm + growingRoom - mm));
      var styles = stock[row.key] || [];

      sizeEl.textContent = sizeName(row);
      metaEl.innerHTML =
        'Based on a foot length of <strong>' + formatCm(mm) + ' cm</strong>' +
        (readAsMm ? ' (read as ' + Math.round(mm) + ' mm)' : '') +
        '<br>Growing room: approximately <strong>' + room + ' mm</strong>';

      if (styles.length && shopBtn) {
        // The collection filtered to this exact size (infant/junior aware);
        // fall back to the first in-stock style if no collection link.
        shopBtn.href = row.shopUrl ? encodeShopUrl(row.shopUrl) : styles[0].url;
        shopLabel.textContent = shopText + ' ' + row.uk;
        shopBtn.hidden = false;
        hideMessage();
      } else {
        if (shopBtn) shopBtn.hidden = true;
        message.textContent = noStockText;
        message.hidden = false;
      }

      answer.hidden = false;
      result.hidden = false;
    }

    function showMessage(text) {
      answer.hidden = true;
      message.textContent = text;
      message.hidden = false;
      result.hidden = false;
    }

    function hideMessage() {
      message.hidden = true;
      message.textContent = '';
    }
  }

  function sizeName(row) {
    // Shoppers say "size 3", not "junior 3"; the range only matters for the filter.
    return 'UK Size ' + row.uk;
  }

  // Filter values contain a space ("Infant 5"); encode it for the query string.
  function encodeShopUrl(url) {
    return String(url).replace(/ /g, '+');
  }

  function formatCm(mm) {
    return String(Math.round(mm) / 10);
  }

  function readJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent || 'null'); } catch (e) { return null; }
  }

  function toNumber(value, fallback) {
    var n = parseFloat(value);
    return isNaN(n) ? fallback : n;
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-size-finder]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-size-finder]');
    if (section) init(section);
  });

  // Links to the finder's anchor (e.g. the "Sized Right" badge -> #size-finder)
  // scroll smoothly and stop just below the sticky header.
  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[href^="#"]') : null;
    if (!link) return;
    var id = link.getAttribute('href').slice(1);
    var anchor = id ? document.getElementById(id) : null;
    if (!anchor || !anchor.hasAttribute('data-size-finder-anchor')) return;

    event.preventDefault();
    var header = document.querySelector('.site-header-shell--sticky');
    var offset = (header ? header.getBoundingClientRect().height : 0) + 16;
    var top = anchor.getBoundingClientRect().top + window.pageYOffset - offset;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    if (window.history && history.replaceState) history.replaceState(null, '', '#' + id);
  });
})();
